export const GET_LOGO_PATH = '/api/security/whitelabel/logo';
export const GET_LOGO_EXPANDED_PATH = '/api/security/whitelabel/logo/expanded';
export const GET_LOGO_COLLAPSED_PATH = '/api/security/whitelabel/logo/collapsed';
export const GET_LEFT_INFOBOX_IMAGE_DEFAULT_PATH = '/images/greendeal-media-social.png';
export const GET_LEFT_INFOBOX_IMAGE_PATH = '/api/security/whitelabel/infobox/image/left';
export const GET_RIGHT_INFOBOX_IMAGE_DEFAULT_PATH = '/images/consulting.png';
export const GET_RIGHT_INFOBOX_IMAGE_PATH = '/api/security/whitelabel/infobox/image/right';
export const GET_LEFT_INFOBOX_URL = 'https://www.dreso.com/de/dreso/nachhaltig/esg-beratung-und-management';
export const GET_RIGHT_INFOBOX_URL = 'https://esg-supertool.com/sustainable-consulting';
